/**
 * Idézet service
 * @author Erik Banhalmi 2017.06.28.
 */
export class QoutationService {
	constructor($http) {
		'ngInject';
		this.$http = $http;
		this.publicRoot = '/public';
		this.privateRoot = '/private';
	}
	getPartnerQoutations() {
		return this.$http.get('/static/json/partner-quotes.json');
	}
	getUspQuotations() {
		return this.$http.get('/static/json/usp-carousel-messages.json');
	}
	getCustomerQoutations() {
		return this.$http.get('/static/json/customer-quotes.json');
	}

	getEmployeeQoutations(maxNumber) {
		return this.$http.get(`${this.publicRoot}/qoutation/employee`, {
			params: {
				maxNumber: maxNumber
			}
		});
	}
	getSimpleQoutations(maxNumber) {
		return this.$http.get(`${this.publicRoot}/qoutation/simple`, {
			params: {
				maxNumber: maxNumber
			}
		});
	}
}
